<template>
  <DsfFormControlBox class="ds-control ds-upload" :owner="_self">
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-slot:content>
      <div v-loading="loading" class="ds-form-item" :class="getCss">
        <el-upload ref="upload"
                   :disabled="readOnly"
                   :style="{
                     width: switchMode ? `${imgWidth}px` : '',
                     height: switchMode ? `${imgHeight}px` : '',
                   }"
                   :class="[
                     { 'avatar-uploader': switchMode },
                     'upload-demo',
                     classObject,
                   ]"
                   :accept="uploadFileExts"
                   :multiple="false"
                   :headers="headersParam"
                   :action="setRequestUrl"
                   :data="extendData"
                   :show-file-list="false"
                   :before-upload="beforeUpload"
                   :on-success="handleSuccess"
                   :on-error="handleError"
                   :on-progress="handleProgress"
                   :auto-upload="autoUpload">
          <template v-if="switchMode">
            <img v-if="multipleFiles.length && !isImageLoadError" :src="$getWebPath(multipleFiles[0].relativePath,true)" class="avatar" fit="cover" @error="imageLoadError" @load="imageLoadSuccess"/>
            <template v-else>
              <img v-if="useDefultHeader" :src="defaultUserIcon" fit="cover" class="avatar"/>
              <img v-else :src="imageUrl[defaultImg]" fit="cover" class="avatar"/>
              <p v-if="isShowTips" class="tips">
                {{ `长 * 宽：${imgWidth}px * ${imgHeight}px` }}
              </p>
            </template>
          </template>
          <template v-else>
            <el-button type="primary" class="ds-button">
              <i class="el-icon-upload el-icon--left"></i>
              {{ btnName }}
            </el-button>
          </template>
        </el-upload>
        <span v-if="showPhotoText" style="color: red; text-align: left">{{
          tipsPhotoText
        }}</span>
        <div v-if="errors.length > 0 && multipleFiles.length <= 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
        <pc-crop-image :show-tips-text="showTipsText" :tips-text="tipsText" :edit-img="editImg" :edit-file-img="editFileImg" :aspect-ratio="aspectRatio" :lock-aspect-ratio="lockAspectRatio" :request-url="requestUrl || 'file/upload/'" :extend-data="extendData" :format="format" @saveFile="editFile" @handleClose="handleClose" />
      </div>
    </template>
  </DsfFormControlBox>
</template>

<script>
import photodefault from "_platform/assets/styles/themes/upload/photodefault.jpg";
import coverdefault from "_platform/assets/styles/themes/upload/coverdefault.png";
import thumbnaildefault from "_platform/assets/styles/themes/upload/thumbnaildefault.png";

export default dsf.component({
  name: "DsfUploadPhoto",
  mixins: [$mixins.formControl],
  ctrlCaption: "上传照片",
  props: {
    label: {
      type: String,
      default: "上传照片"
    },
    //是否显示label
    showLabel: {
      type: Boolean,
      default: false
    },
    btnName: {
      type: String,
      default: "上传照片"
    },
    isShowTips: {
      type: Boolean,
      default: true
    },
    isCutPic: {
      type: Boolean,
      default: true
    },
    imgWidth: {
      type: [Number, String],
      default: "180"
    },
    imgHeight: {
      type: [Number, String],
      default: "230"
    },
    maxFileSize: {
      type: [Number, String],
      default: 2048
    },
    minFileSize: {
      type: String,
      default: "0"
    },
    required: {
      type: Boolean,
      default: false
    },
    defaultImg: {
      type: [Number, String],
      default: "0"
    },
    photoCard: {
      type: String,
      default: ""
    },
    hasPadding: {
      type: [Boolean, Number, String],
      default: true
    },
    hasBorder: {
      type: [Boolean, Number, String],
      default: true
    },
    // 剪裁比例
    aspectRatio: {
      type: String,
      default: "1/1"
    },
    // 锁定剪裁比例
    lockAspectRatio: {
      type: Boolean,
      default: true
    },
    switchMode: {
      type: Boolean,
      default: true
    },
    requestUrl: {
      type: String,
      default: ""
    },
    showPhotoText: {
      type: Boolean,
      default: false
    },
    tipsPhotoText: {
      type: String,
      default: "请上传0.5-2MB大小，JPG、JPEG、PNG格式的免冠证件照"
    },
    showTipsText: {
      type: Boolean,
      default: false
    },
    tipsText: {
      type: String,
      default: "请将照片放于深色区域内"
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("photo-meta-data", {
          valueAttributes: [
            {
              name: "上传照片",
              code: "photo",
              type: dsf.metadata.getDataType("object"),
              length: 500,
              defaultValue: null,
              unit: null,
              textType: "JSON"
            }
          ]
        });
      }
    },
    // 是否静态，为true时isPublic失效
    isStatic: {
      type: Boolean,
      default: false
    },
    // 是否公开
    isPublic: {
      type: Boolean,
      default: true
    },
    // 导出格式image/jpeg、image/png
    format: {
      type: String,
      default: "image/jpeg"
    },
    useDefultHeader: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    defaultImg(nv) {
      this.$emit("update:imgWidth", [180, 120][Number(nv) === 3 ? 1 : 0]);
      this.$emit("update:imgHeight", [230, 120][Number(nv) === 3 ? 1 : 0]);
    }
  },
  data() {
    return {
      loading: false,
      autoUpload: true,
      // multipleFiles: "", // 上传文件数组
      uploadFileExts: ".jpg,.jpeg,.png,.gif", //允许上传后缀名
      acceptMime: "", // 弹窗筛选条件MiMe类型
      headersParam: {
        "X-XSRF-TOKEN": dsf.getCookie("XSRF-TOKEN") || "",
        ...dsf.getTokenHttpHeader()
      },
      imageUrl: [],
      editImg: false,
      editFileImg: {},
      isImageLoadError: false
    };
  },
  created() {
    this.imageUrl = [photodefault, coverdefault, dsf.config?.[this.photoCard], thumbnaildefault];
    if (this.isDesign) {
      if (!dsf.isBoolean(this.hasPadding)) {
        this.$emit("update:hasPadding", this.hasPadding == "1");
      }
      if (!dsf.isBoolean(this.hasBorder)) {
        this.$emit("update:hasBorder", this.hasBorder == "1");
      }
    }
  },
  computed: {
    setRequestUrl() {
      return this.$getWebPath(this.requestUrl || "file/upload/", true);
    },
    multipleFiles: {
      get() {
        let files = [];
        if (this.value !== "" && dsf.isDef(this.value) && typeof this.value === "string") {
          files = JSON.parse(this.value);
        }
        return files;
      },
      set(v) {
        this.emitValueChange(JSON.stringify(v));
      }
    },
    classObject() {
      return {
        padding: this.hasPadding === true || this.hasPadding == "1",
        border: this.hasBorder === true || this.hasBorder == "1"
      };
    },
    extendData() {
      let { isStatic, isPublic } = this;
      let res = {
        isStatic: Number(isStatic),
        isPublic: Number(isPublic)
      };
      if (isStatic && this.$vm) {
        res["namespace"] = this.$vm.nameSpace;
        res["pageName"] = this.$vm.pageName;
      }
      return res;
    },
    // 用户默认头像
    defaultUserIcon() {
      let url = dsf.config.setting_public_user_default_header;
      return this.$replace(url);
    },
  },
  methods: {
    beforeUpload(file) {
      // 判断文件格式
      if (this.uploadFileExts) {
        let dotIndex = file.name.lastIndexOf(".");
        let testmsg = "";
        if (dotIndex > 0) {
          testmsg = file.name.substring(dotIndex).toLowerCase();
        }
        let arr = _.filter(this?.uploadFileExts?.split?.(",") || [], (it) => it);
        if (!~arr.indexOf(testmsg)) {
          dsf.layer.message(`选择文件中包含不支持的文件格式,请选择包含这些格式的文件：${this.uploadFileExts}`, false);
          return false;
        }
      }
      // 判断文件大小
      let minSize = _.isNaN(parseInt(this.minFileSize)) ? 0 : parseInt(this.minFileSize) * 1024;
      let isMinSize = minSize ? file.size > minSize : true;
      let maxFileSize = this.maxFileSize + "";
      let fileSize = maxFileSize.toLocaleLowerCase().indexOf("m") > -1 ? parseInt(maxFileSize) * 1024 * 1024 : parseInt(maxFileSize) * 1024;
      let maxSize = _.isNaN(parseInt(maxFileSize)) ? 0 : fileSize;
      let isMaxSize = maxSize ? file.size < maxSize : true;
      if (!isMaxSize || !isMinSize) {
        let sizeInfo = !isMinSize ? ["小于", minSize] : ["大于", maxSize];
        dsf.layer.message(`文件大小不能${sizeInfo[0]}${this.formatBytes(sizeInfo[1])}`, false);
        return false;
      }
    },
    formatBytes(a, b) {
      // a 参数：表示要被转化的容量大小，以字节为单
      // b 参数：表示如果转换时出小数，四舍五入保留多少位 默认为2位小数
      if (0 == a) return "0 B";
      var c = 1024,
        d = b || 2,
        e = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        f = Math.floor(Math.log(a) / Math.log(c));
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
    },
    handleProgress() {
      this.loading = true;
    },
    //上传成功
    handleSuccess(response) {
      this.loading = false;
      if (response.success && response.state == 20000) {
        if (this.isCutPic) {
          this.editImg = true;
          this.editFileImg = response.data[0];
        } else {
          this.multipleFiles.push(response.data[0]);
          if (this.multipleFiles.length > 1) {
            let files = this.multipleFiles.splice(1, 1);
            this.emitValueChange(JSON.stringify(files));
          } else {
            this.emitValueChange(JSON.stringify(this.multipleFiles));
          }
        }
      }
    },
    //上传失败
    handleError() {
      this.loading = false;
      dsf.layer.message("上传失败", false);
    },
    //获取文件大小
    getFileSize(data) {
      let fileSize = parseInt(data);
      if (data.indexOf("M") > -1 || data.indexOf("m") > -1) {
        fileSize = parseInt(data) * 1024;
      }
      return fileSize;
    },
    editFile(files) {
      this.editImg = false;
      this.multipleFiles.push(files);
      if (this.multipleFiles.length > 1) {
        let files = this.multipleFiles.splice(1, 1);
        this.emitValueChange(JSON.stringify(files));
      } else {
        this.emitValueChange(JSON.stringify(this.multipleFiles));
      }
    },
    handleClose() {
      this.editImg = false;
    },
    getPhoto(imgs) {
      if (!imgs || imgs === "[]" || _.isEqual(imgs, [])) {
        return [];
      }
      let _imgs = !_.isArray(imgs) ? JSON.parse(imgs) : imgs;
      return _imgs.map((v) => (v.relativePath ? this.$getWebPath(v.relativePath, true) : v));
    },
    // 图片加载成功
    imageLoadSuccess() {
      this.isImageLoadError = false
    },
    // 图片加载失败
    imageLoadError() {
      this.isImageLoadError = true;
    }
  }
});
</script>
